import { render, staticRenderFns } from "./LoanApplicationLoading.vue?vue&type=template&id=2a24704e&"
import script from "./LoanApplicationLoading.vue?vue&type=script&lang=js&"
export * from "./LoanApplicationLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports